export type AdsMode = "off" | "test" | "production";

export interface AdsConfig {
  mode: AdsMode;
  clientId: string | null;
  slot: string | null;
}

// AdSense publisher IDs and ad unit IDs are public identifiers. Keep the
// display unit configurable because the existing SUREvAI app has no slot yet.
export function getAdsConfig(): AdsConfig {
  const requestedMode = import.meta.env.VITE_ADS_MODE;
  const mode: AdsMode = requestedMode === "production" || requestedMode === "test" ? requestedMode : "off";
  const clientId = String(import.meta.env.VITE_ADS_CLIENT_ID || "ca-pub-1421110711561858").trim();
  const slot = String(import.meta.env.VITE_ADS_SLOT || "").trim();
  if (mode === "production" && (!/^ca-pub-\d{16}$/.test(clientId) || !/^\d+$/.test(slot))) {
    return { mode: "off", clientId: null, slot: null };
  }
  return { mode, clientId: mode === "production" ? clientId : null, slot: mode === "production" ? slot : null };
}
